module.exports = __webpack_public_path__ + "img/013-Pharmacist.cb799f99.png";